/** Garbage values that sometimes leak into URLs as the literal string. */
const BLOCKED_SYMBOLS = new Set([
    'UNDEFINED',
    'NULL',
    'NAN',
    'TRUE',
    'FALSE',
    'SYMBOL',
    'PAIR',
    'NONE',
    'N/A',
]);
/**
 * Normalize a desk / WEEX USDT-M symbol for market requests.
 * Returns null when the value must not be sent to WEEX (avoids -1142 and sticky Market weak).
 */
export const sanitizeMarketSymbol = (raw) => {
    const s = String(raw ?? '')
        .trim()
        .toUpperCase()
        .replace(/^CMT_/, '')
        .replace(/[^A-Z0-9]/g, '');
    if (!s || BLOCKED_SYMBOLS.has(s))
        return null;
    if (!/^[A-Z0-9]{2,24}(USDT|USDC)$/.test(s))
        return null;
    return s;
};
export const isWeexSymbolError = (text) => /Parameter ['"]symbol['"]|invalid symbol|-1142|symbol is invalid/i.test(String(text || ''));
/** Strip raw WEEX JSON dumps from UI banners. */
export const friendlyMarketError = (text, fallback = 'Market error') => {
    const raw = String(text || '').trim();
    if (!raw)
        return fallback;
    if (isWeexSymbolError(raw))
        return fallback;
    // Collapse `WEEX GET … failed (400): {"code":-1142,"msg":"…"}` style payloads.
    const msg = raw.match(/"msg"\s*:\s*"([^"]+)"/);
    if (msg?.[1] && /symbol/i.test(msg[1]))
        return fallback;
    if (/WEEX\s+\w+\s+\/capi/i.test(raw) && raw.length > 120) {
        return fallback;
    }
    return raw.length > 180 ? `${raw.slice(0, 177)}…` : raw;
};
